export const production = true;
let config;
if (production) {
    config = {
        "miniAppId": "1d779fb0-e2e1-11eb-a1bb-0242ac120029",
        "api-key": "6b6S7vxmm9JjSduH",
        "webAPI": "ce15f30b-fb9b-4baf-b0f1-6ab88b3baa2f",
        "appId": "hamropatro",
    };
}
else {
    config = {
        "miniAppId": "059fa330-fa5e-11eb-8cef-0242ac120039",
        "api-key": "rUyFz3QPQzWtVjeg",
        "webAPI": "ce15f30b-fb9b-4baf-b0f1-6ab88b3baa2f",
        "appId": "hamropatro-android",
    };
}
export default config;
